import { getAddressFieldConditionalComponents } from '../../../document/components/AddressField.tsx';
import { ArticleNumberFieldConditionalComponents } from '../../../document/components/ArticleNumberField.tsx';
import { getContactFieldConditionalComponents } from '../../../document/components/ContactField.tsx';
import {
    getCustomerFieldConditionalComponents,
    getCustomerFieldGroupConditionalComponents,
} from '../../../document/components/CustomerField.tsx';
import { DocumentType } from '../../../document/constants.ts';
import DocumentAssistance from '../../../document/pages/Assistance';
import {
    ASSISTANCE_PATH,
    ASSISTANCE_TAB_PATH,
    CHANNEL_FINISHED_PATH,
    CHANNEL_PATH,
    CHANNEL_TESTING_PATH,
    OVERVIEW_FINISHED_PATH,
    OVERVIEW_PATH,
    OVERVIEW_TESTING_PATH,
} from '../constants.ts';
import {
    GET_CHANNELS_OVERVIEW_DATA,
    GET_ASSISTANCE_OVERVIEW_DATA,
    GET_NEXT_ASSISTANCE_RECORD,
    GET_RELATED_DOCUMENT,
    RE_UPLOAD_FILE,
    REOPEN_FOR_ASSISTANCE,
    RETRY_STEP,
    RFQ_EXTRACT_TEXT,
    SEND_TO_LABELING,
} from '../queries.ts';

export const documentTypeName = 'rfq';

const fieldNameToGroupTypeMap = {
    customer: 'CustomerField',
    deliveryAddress: 'AddressField',
    invoiceAddress: 'AddressField',
    customerContact: 'ContactField',
};

const RfqAssistance = (props) => {
    const documentConfiguration = {
        documentType: DocumentType.Rfq,
        documentTypeName: 'rfq',
        supportsAgenticExtraction: true,
        GET_ASSISTANCE_OVERVIEW_DATA: GET_ASSISTANCE_OVERVIEW_DATA,
        GET_CHANNELS_OVERVIEW_DATA: GET_CHANNELS_OVERVIEW_DATA,
        GET_NEXT_ASSISTANCE_RECORD: GET_NEXT_ASSISTANCE_RECORD,
        GET_RELATED_DOCUMENT: GET_RELATED_DOCUMENT,
        RETRY_STEP: RETRY_STEP,
        REOPEN_FOR_ASSISTANCE: REOPEN_FOR_ASSISTANCE,
        ASSISTANCE_PATH: ASSISTANCE_PATH,
        ASSISTANCE_TAB_PATH: ASSISTANCE_TAB_PATH,
        OVERVIEW_PATH: OVERVIEW_PATH,
        OVERVIEW_FINISHED_PATH: OVERVIEW_FINISHED_PATH,
        OVERVIEW_TESTING_PATH: OVERVIEW_TESTING_PATH,
        CHANNEL_PATH: CHANNEL_PATH,
        CHANNEL_FINISHED_PATH: CHANNEL_FINISHED_PATH,
        CHANNEL_TESTING_PATH: CHANNEL_TESTING_PATH,
        RE_UPLOAD_FILE: RE_UPLOAD_FILE,
        EXTRACT_TEXT: RFQ_EXTRACT_TEXT,
        SEND_TO_LABELING: SEND_TO_LABELING,
        components: {
            Field: [
                ...getCustomerFieldConditionalComponents('customer'),
                ...getContactFieldConditionalComponents('customer_contact'),
                ...getAddressFieldConditionalComponents('delivery_address'),
                ...getAddressFieldConditionalComponents('invoice_address'),
                ...ArticleNumberFieldConditionalComponents,
            ],
            HeaderDataFieldGroup: [...getCustomerFieldGroupConditionalComponents('customer')],
        },
    };

    return <DocumentAssistance documentConfiguration={documentConfiguration} {...props} />;
};

export default RfqAssistance;
